const languageCodeTypes = {
	EN: 'en',
	EN_UD: 'en-UD',
	EN_AR: 'en-AR',
	EN_AU: 'en-AU',
	EN_BZ: 'en-BZ',
	EN_CA: 'en-CA',
	EN_CB: 'en-CB',
	EN_CN: 'en-CN',
	EN_DK: 'en-DK',
	EN_HK: 'en-HK',
	EN_IN: 'en-IN',
	EN_ID: 'en-ID',
	EN_IE: 'en-IE',
	EN_JM: 'en-JM',
	EN_JA: 'en-JA',
	EN_MY: 'en-MY',
	EN_NZ: 'en-NZ',
	EN_NO: 'en-NO',
	EN_PH: 'en-PH',
	EN_PR: 'en-PR',
	EN_SG: 'en-SG',
	EN_ZA: 'en-ZA',
	EN_SE: 'en-SE',
	EN_GB: 'en-GB',
	EN_US: 'en-US',
	EN_ZW: 'en-ZW',
	AA: 'aa',
	AB: 'ab',
	AE: 'ae',
	AF: 'af',
	AK: 'ak',
	AM: 'am',
	AN: 'an',
	AR: 'ar',
	AR_BH: 'ar-BH',
	AR_EG: 'ar-EG',
	AR_SA: 'ar-SA',
	AR_YE: 'ar-YE',
	AS: 'as',
	AST: 'ast',
	AV: 'av',
	AY: 'ay',
	AZ: 'az',
	BA: 'ba',
	BAL: 'bal',
	BAN: 'ban',
	BE: 'be',
	BER: 'ber',
	BG: 'bg',
	BH: 'bh',
	BI: 'bi',
	BM: 'bm',
	BN: 'bn',
	BN_IN: 'Bengali, India',
	BO: 'bo',
	BR: 'br',
	BR_FR: 'br-FR',
	BS: 'bs',
	CA: 'ca',
	CE: 'ce',
	CEB: 'ceb',
	CHR: 'chr',
	CO: 'co',
	CS: 'cs',
	CY: 'cy',
	DA: 'da',
	DE: 'de',
	DE_AT: 'de-AT',
	DE_BE: 'de-BE',
	DE_LI: 'de-LI',
	DE_LU: 'de-LU',
	DE_CH: 'de-CH',
	DZ: 'dz',
	EE: 'ee',
	EL: 'el',
	EL_CY: 'el-CY',
	EO: 'eo',
	ES: 'es',
	ES_ES: 'es-ES',
	ES_EM: 'es-EM',
	ES_AR: 'es-AR',
	ES_BO: 'es-BO',
	ES_CL: 'es-CL',
	ES_CO: 'es-CO',
	ES_CR: 'es-CR',
	ES_DO: 'es-DO',
	ES_EC: 'es-EC',
	ES_SV: 'es-SV',
	ES_GT: 'es-GT',
	ES_HN: 'es-HN',
	ES_MX: 'es-MX',
	ES_NI: 'es-NI',
	ES_PA: 'es-PA',
	ES_PY: 'es-PY',
	ES_PE: 'es-PE',
	ES_PR: 'es-PR',
	ES_US: 'es-US',
	ES_UY: 'es-UY',
	ES_VE: 'es-VE',
	ES_419: 'es-419',
	ET: 'et',
	EU: 'eu',
	FA: 'fa',
	FA_AF: 'fa-AF',
	FA_IR: 'fa-IR',
	FI: 'fi',
	FJ: 'fj',
	FO: 'fo',
	FR: 'fr',
	FR_BE: 'fr-BE',
	FR_CA: 'fr-CA',
	FR_LU: 'fr-LU',
	FR_QC: 'fr-QC',
	FR_CH: 'fr-CH',
	FRA_DE: 'fra-DE',
	FRP: 'frp',
	FUR_IT: 'fur-IT',
	FY: 'fy',
	FY_NL: 'fy-NL',
	GA: 'ga',
	GD: 'gd',
	GL: 'gl',
	GN: 'gn',
	GU: 'gu',
	GU_IN: 'gu-IN',
	HA: 'ha',
	HI: 'hi',
	HR: 'hr',
	HU: 'hu',
	HY: 'hy',
	HY_AM: 'hy-AM',
	IA: 'ia',
	IE: 'ie',
	IK: 'ik',
	ID: 'id',
	IS: 'is',
	IT: 'it',
	IT_CH: 'it-CH',
	IW: 'iw',
	JA: 'ja',
	JI: 'ji',
	JW: 'jw',
	KA: 'ka',
	KK: 'kk',
	KL: 'kl',
	KM: 'km',
	KN: 'kn',
	KO: 'ko',
	KS: 'ks',
	KS_PK: 'ks-PK',
	KU: 'ku',
	KY: 'ky',
	LA: 'la',
	LA_LA: 'la-LA',
	LN: 'ln',
	LO: 'lo',
	LT: 'lt',
	LV: 'lv',
	MG: 'mg',
	MI: 'mi',
	MK: 'mk',
	ML: 'ml',
	MN: 'mn',
	MO: 'mo',
	MR: 'mr',
	MS: 'ms',
	MT: 'mt',
	MY: 'my',
	NA: 'na',
	NE: 'ne',
	NL: 'nl',
	NL_BE: 'nl-BE',
	NL_SR: 'nl-SR',
	NO: 'no',
	OC: 'oc',
	OM: 'om',
	PA: 'pa',
	PA_IN: 'pa-IN',
	PA_PK: 'pa-PK',
	PL: 'pl',
	PS: 'ps',
	PT: 'pt',
	PT_PT: 'pt-PT',
	PT_BR: 'pt-BR',
	QU: 'qu',
	RM: 'rm',
	RN: 'rn',
	RO: 'ro',
	RU: 'ru',
	RU_BY: 'ru-BY',
	RU_MD: 'ru-MD',
	RU_UA: 'ru-UA',
	RW: 'rw',
	SA: 'sa',
	SD: 'sd',
	SG: 'sg',
	SH: 'sh',
	SI: 'si',
	SI_LK: 'si-LK',
	SK: 'sk',
	SL: 'sl',
	SM: 'sm',
	SN: 'sn',
	SO: 'so',
	SQ: 'sq',
	SR: 'sr',
	SS: 'ss',
	ST: 'st',
	SU: 'su',
	SV: 'sv',
	SW: 'sw',
	TA: 'ta',
	TAY: 'tay',
	TE: 'te',
	TG: 'tg',
	TH: 'th',
	TI: 'ti',
	TK: 'tk',
	TL: 'tl',
	TN: 'tn',
	TO: 'to',
	TR: 'tr',
	TS: 'ts',
	TT: 'tt',
	TW: 'tw',
	UK: 'uk',
	UR: 'ur',
	UZ: 'uz',
	VI: 'vi',
	VLS_BE: 'vls-BE',
	VO: 'vo',
	WO: 'wo',
	XH: 'xh',
	YO: 'yo',
	ZH: 'zh',
	ZH_CN: 'zh-CN',
	ZH_TW: 'zh-TW',
	ZH_HANS: 'zh-Hans',
	ZH_HK: 'zh-HK',
	ZH_MO: 'zh-MO',
	ZH_SG: 'zh-SG',
	ZU: 'zu',
}

export const languageCodeTypesNames = {
	[languageCodeTypes.EN]: 'English',
	[languageCodeTypes.EN_UD]: 'English (upside down)',
	[languageCodeTypes.EN_AR]: 'English, Arabia',
	[languageCodeTypes.EN_AU]: 'English, Australia',
	[languageCodeTypes.EN_BZ]: 'English, Belize',
	[languageCodeTypes.EN_CA]: 'English, Canada',
	[languageCodeTypes.EN_CB]: 'English, Caribbean',
	[languageCodeTypes.EN_CN]: 'English, China',
	[languageCodeTypes.EN_DK]: 'English, Denmark',
	[languageCodeTypes.EN_HK]: 'English, Hong Kong',
	[languageCodeTypes.EN_IN]: 'English, India',
	[languageCodeTypes.EN_ID]: 'English, Indonesia',
	[languageCodeTypes.EN_IE]: 'English, Ireland',
	[languageCodeTypes.EN_JM]: 'English, Jamaica',
	[languageCodeTypes.EN_JA]: 'English, Japan',
	[languageCodeTypes.EN_MY]: 'English, Malaysia',
	[languageCodeTypes.EN_NZ]: 'English, New Zealand',
	[languageCodeTypes.EN_NO]: 'English, Norway',
	[languageCodeTypes.EN_PH]: 'English, Philippines',
	[languageCodeTypes.EN_PR]: 'English, Puerto Rico',
	[languageCodeTypes.EN_SG]: 'English, Singapore',
	[languageCodeTypes.EN_ZA]: 'English, South Africa',
	[languageCodeTypes.EN_SE]: 'English, Sweden',
	[languageCodeTypes.EN_GB]: 'English, United Kingdom',
	[languageCodeTypes.EN_US]: 'English, United States',
	[languageCodeTypes.EN_ZW]: 'English, Zimbabwe',
	[languageCodeTypes.AA]: 'Afar',
	[languageCodeTypes.AB]: 'Abkhazian',
	[languageCodeTypes.AE]: 'Avestan',
	[languageCodeTypes.AF]: 'Afrikaans',
	[languageCodeTypes.AK]: 'Akan',
	[languageCodeTypes.AM]: 'Amharic',
	[languageCodeTypes.AN]: 'Aragonese',
	[languageCodeTypes.AR]: 'Arabic',
	[languageCodeTypes.AR_BH]: 'Arabic, Bahrain',
	[languageCodeTypes.AR_EG]: 'Arabic, Egypt',
	[languageCodeTypes.AR_SA]: 'Arabic, Saudi Arabia',
	[languageCodeTypes.AR_YE]: 'Arabic, Yemen',
	[languageCodeTypes.AS]: 'Assamese',
	[languageCodeTypes.AST]: 'Asturian',
	[languageCodeTypes.AV]: 'Avaric',
	[languageCodeTypes.AY]: 'Aymara',
	[languageCodeTypes.AZ]: 'Azerbaijani',
	[languageCodeTypes.BA]: 'Bashkir',
	[languageCodeTypes.BAL]: 'Balochi',
	[languageCodeTypes.BAN]: 'Balinese',
	[languageCodeTypes.BE]: 'Byelorussian',
	[languageCodeTypes.BER]: 'Berber',
	[languageCodeTypes.BG]: 'Bulgarian',
	[languageCodeTypes.BH]: 'Bihari',
	[languageCodeTypes.BI]: 'Bislama',
	[languageCodeTypes.BM]: 'Bambara',
	[languageCodeTypes.BN]: 'Bengali, Bangla',
	[languageCodeTypes.BN_IN]: 'Bengali, India',
	[languageCodeTypes.BO]: 'Tibetan',
	[languageCodeTypes.BR]: 'Breton',
	[languageCodeTypes.BR_FR]: 'Breton',
	[languageCodeTypes.BS]: 'Bosnian',
	[languageCodeTypes.CA]: 'Catalan',
	[languageCodeTypes.CE]: 'Chechen',
	[languageCodeTypes.CEB]: 'Cebuano',
	[languageCodeTypes.CHR]: 'Cherokee',
	[languageCodeTypes.CO]: 'Corsican',
	[languageCodeTypes.CS]: 'Czech',
	[languageCodeTypes.CY]: 'Welsh',
	[languageCodeTypes.DA]: 'Danish',
	[languageCodeTypes.DE]: 'German',
	[languageCodeTypes.DE_AT]: 'German, Austria',
	[languageCodeTypes.DE_BE]: 'German, Belgium',
	[languageCodeTypes.DE_LI]: 'German, Liechtenstein',
	[languageCodeTypes.DE_LU]: 'German, Luxembourg',
	[languageCodeTypes.DE_CH]: 'German, Switzerland',
	[languageCodeTypes.DZ]: 'Bhutani',
	[languageCodeTypes.EE]: 'Ewe',
	[languageCodeTypes.EL]: 'Greek',
	[languageCodeTypes.EL_CY]: 'Greek, Cyprus',
	[languageCodeTypes.EO]: 'Esperanto',
	[languageCodeTypes.ES]: 'Spanish',
	[languageCodeTypes.ES_ES]: 'Spanish',
	[languageCodeTypes.ES_EM]: 'Spanish (Modern)',
	[languageCodeTypes.ES_AR]: 'Spanish, Argentina',
	[languageCodeTypes.ES_BO]: 'Spanish, Bolivia',
	[languageCodeTypes.ES_CL]: 'Spanish, Chile',
	[languageCodeTypes.ES_CO]: 'Spanish, Colombia',
	[languageCodeTypes.ES_CR]: 'Spanish, Costa Rica',
	[languageCodeTypes.ES_DO]: 'Spanish, Dominican Republic',
	[languageCodeTypes.ES_EC]: 'Spanish, Ecuador',
	[languageCodeTypes.ES_SV]: 'Spanish, El Salvador',
	[languageCodeTypes.ES_GT]: 'Spanish, Guatemala',
	[languageCodeTypes.ES_HN]: 'Spanish, Honduras',
	[languageCodeTypes.ES_MX]: 'Spanish, Mexico',
	[languageCodeTypes.ES_NI]: 'Spanish, Nicaragua',
	[languageCodeTypes.ES_PA]: 'Spanish, Panama',
	[languageCodeTypes.ES_PY]: 'Spanish, Paraguay',
	[languageCodeTypes.ES_PE]: 'Spanish, Peru',
	[languageCodeTypes.ES_PR]: 'Spanish, Puerto Rico',
	[languageCodeTypes.ES_US]: 'Spanish, United States',
	[languageCodeTypes.ES_UY]: 'Spanish, Uruguay',
	[languageCodeTypes.ES_VE]: 'Spanish, Venezuela',
	[languageCodeTypes.ES_419]: 'Spanish (Latin America)',
	[languageCodeTypes.ET]: 'Estonian',
	[languageCodeTypes.EU]: 'Basque',
	[languageCodeTypes.FA]: 'Persian',
	[languageCodeTypes.FA_AF]: 'Dari',
	[languageCodeTypes.FA_IR]: 'Farsi, Iran',
	[languageCodeTypes.FI]: 'Finnish',
	[languageCodeTypes.FJ]: 'Fiji',
	[languageCodeTypes.FO]: 'Faeroese',
	[languageCodeTypes.FR]: 'French',
	[languageCodeTypes.FR_BE]: 'French, Belgium',
	[languageCodeTypes.FR_CA]: 'French, Canada',
	[languageCodeTypes.FR_LU]: 'French, Luxembourg',
	[languageCodeTypes.FR_QC]: 'French, Quebec',
	[languageCodeTypes.FR_CH]: 'French, Switzerland',
	[languageCodeTypes.FRA_DE]: 'Franconian',
	[languageCodeTypes.FRP]: 'Arpitan',
	[languageCodeTypes.FUR_IT]: 'Friulian',
	[languageCodeTypes.FY]: 'Frisian',
	[languageCodeTypes.FY_NL]: 'Frisian',
	[languageCodeTypes.GA]: 'Irish',
	[languageCodeTypes.GD]: 'Scots/Gaelic',
	[languageCodeTypes.GL]: 'Galician',
	[languageCodeTypes.GN]: 'Guarani',
	[languageCodeTypes.GU]: 'Gujarati',
	[languageCodeTypes.GU_IN]: 'Gujarati',
	[languageCodeTypes.HA]: 'Hausa',
	[languageCodeTypes.HI]: 'Hindi',
	[languageCodeTypes.HR]: 'Croatian',
	[languageCodeTypes.HU]: 'Hungarian',
	[languageCodeTypes.HY]: 'Armenian',
	[languageCodeTypes.HY_AM]: 'Armenian',
	[languageCodeTypes.IA]: 'Interlingua',
	[languageCodeTypes.IE]: 'Interlingue',
	[languageCodeTypes.IK]: 'Inupiak',
	[languageCodeTypes.ID]: 'Indonesian',
	[languageCodeTypes.IS]: 'Icelandic',
	[languageCodeTypes.IT]: 'Italian',
	[languageCodeTypes.IT_CH]: 'Italian, Switzerland',
	[languageCodeTypes.IW]: 'Hebrew',
	[languageCodeTypes.JA]: 'Japanese',
	[languageCodeTypes.JI]: 'Yiddish',
	[languageCodeTypes.JW]: 'Javanese',
	[languageCodeTypes.KA]: 'Georgian',
	[languageCodeTypes.KK]: 'Kazakh',
	[languageCodeTypes.KL]: 'Greenlandic',
	[languageCodeTypes.KM]: 'Cambodian',
	[languageCodeTypes.KN]: 'Kannada',
	[languageCodeTypes.KO]: 'Korean',
	[languageCodeTypes.KS]: 'Kashmiri',
	[languageCodeTypes.KS_PK]: 'Kashmiri, Pakistan',
	[languageCodeTypes.KU]: 'Kurdish',
	[languageCodeTypes.KY]: 'Kirghiz',
	[languageCodeTypes.LA]: 'Latin',
	[languageCodeTypes.LA_LA]: 'Latin',
	[languageCodeTypes.LN]: 'Lingala',
	[languageCodeTypes.LO]: 'Laothian',
	[languageCodeTypes.LT]: 'Lithuanian',
	[languageCodeTypes.LV]: 'Latvian/Lettish',
	[languageCodeTypes.MG]: 'Malagasy',
	[languageCodeTypes.MI]: 'Maori',
	[languageCodeTypes.MK]: 'Macedonian',
	[languageCodeTypes.ML]: 'Malayalam',
	[languageCodeTypes.MN]: 'Mongolian',
	[languageCodeTypes.MO]: 'Moldavian',
	[languageCodeTypes.MR]: 'Marathi',
	[languageCodeTypes.MS]: 'Malay',
	[languageCodeTypes.MT]: 'Maltese',
	[languageCodeTypes.MY]: 'Burmese',
	[languageCodeTypes.NA]: 'Nauru',
	[languageCodeTypes.NE]: 'Nepali',
	[languageCodeTypes.NL]: 'Dutch',
	[languageCodeTypes.NL_BE]: 'Dutch, Belgium',
	[languageCodeTypes.NL_SR]: 'Dutch, Suriname',
	[languageCodeTypes.NO]: 'Norwegian',
	[languageCodeTypes.OC]: 'Occitan',
	[languageCodeTypes.OM]: '(Afan)/Oromoor/Oriya',
	[languageCodeTypes.PA]: 'Punjabi',
	[languageCodeTypes.PA_IN]: 'Punjabi',
	[languageCodeTypes.PA_PK]: 'Punjabi, Pakistan',
	[languageCodeTypes.PL]: 'Polish',
	[languageCodeTypes.PS]: 'Pashto',
	[languageCodeTypes.PT]: 'Portuguese',
	[languageCodeTypes.PT_PT]: 'Portuguese',
	[languageCodeTypes.PT_BR]: 'Portuguese, Brazilian',
	[languageCodeTypes.QU]: 'Quechua',
	[languageCodeTypes.RM]: 'Rhaeto-Romance',
	[languageCodeTypes.RN]: 'Kirundi',
	[languageCodeTypes.RO]: 'Romanian',
	[languageCodeTypes.RU]: 'Russian',
	[languageCodeTypes.RU_BY]: 'Russian, Belarus',
	[languageCodeTypes.RU_MD]: 'Russian, Moldova',
	[languageCodeTypes.RU_UA]: 'Russian, Ukraine',
	[languageCodeTypes.RW]: 'Kinyarwanda',
	[languageCodeTypes.SA]: 'Sanskrit',
	[languageCodeTypes.SD]: 'Sindhi',
	[languageCodeTypes.SG]: 'Sangro',
	[languageCodeTypes.SH]: 'Serbo-Croatian',
	[languageCodeTypes.SI]: 'Singhalese',
	[languageCodeTypes.SI_LK]: 'Sinhala',
	[languageCodeTypes.SK]: 'Slovak',
	[languageCodeTypes.SL]: 'Slovenian',
	[languageCodeTypes.SM]: 'Samoan',
	[languageCodeTypes.SN]: 'Shona',
	[languageCodeTypes.SO]: 'Somali',
	[languageCodeTypes.SQ]: 'Albanian',
	[languageCodeTypes.SR]: 'Serbian',
	[languageCodeTypes.SS]: 'Siswati',
	[languageCodeTypes.ST]: 'Sesotho',
	[languageCodeTypes.SU]: 'Sundanese',
	[languageCodeTypes.SV]: 'Swedish',
	[languageCodeTypes.SW]: 'Swahili',
	[languageCodeTypes.TA]: 'Tamil',
	[languageCodeTypes.TAY]: 'Atayal',
	[languageCodeTypes.TE]: 'Tegulu',
	[languageCodeTypes.TG]: 'Tajik',
	[languageCodeTypes.TH]: 'Thai',
	[languageCodeTypes.TI]: 'Tigrinya',
	[languageCodeTypes.TK]: 'Turkmen',
	[languageCodeTypes.TL]: 'Tagalog',
	[languageCodeTypes.TN]: 'Setswana',
	[languageCodeTypes.TO]: 'Tonga',
	[languageCodeTypes.TR]: 'Turkish',
	[languageCodeTypes.TS]: 'Tsonga',
	[languageCodeTypes.TT]: 'Tatar',
	[languageCodeTypes.TW]: 'Akan, Twi',
	[languageCodeTypes.UK]: 'Ukrainian',
	[languageCodeTypes.UR]: 'Urdu',
	[languageCodeTypes.UZ]: 'Uzbek',
	[languageCodeTypes.VI]: 'Vietnamese',
	[languageCodeTypes.VLS_BE]: 'Flemish',
	[languageCodeTypes.VO]: 'Volapuk',
	[languageCodeTypes.WO]: 'Wolof',
	[languageCodeTypes.XH]: 'Xhosa',
	[languageCodeTypes.YO]: 'Yoruba',
	[languageCodeTypes.ZH]: 'Chinese',
	[languageCodeTypes.ZH_CN]: 'Chinese Simplified',
	[languageCodeTypes.ZH_TW]: 'Chinese Traditional',
	[languageCodeTypes.ZH_HANS]: 'Chinese Simplified',
	[languageCodeTypes.ZH_HK]: 'Chinese Traditional, Hong Kong',
	[languageCodeTypes.ZH_MO]: 'Chinese Traditional, Macau',
	[languageCodeTypes.ZH_SG]: 'Chinese Traditional, Singapore',
	[languageCodeTypes.ZU]: 'Zulu',
}

export default languageCodeTypes
